<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.ambassador.read")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <AveineAmbassadorSheet :APIbaseURL="APIbaseURL" :ambassador="ambassador" :invitation="invitation" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAmbassadorSheet } from 'aveine-ambassador'
import { Ambassador } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'

export default {
  data () {
    return {
      ambassador: {},
      invitation: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineAmbassadorSheet
  },
  async created() {
    try {
      await Ambassador.api().get(`ambassadors/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          baseURL: this.APIbaseURL,
          params: {
            include:
            'user,country',
          }
        }
      );
      this.ambassador = await Ambassador.query().whereId(this.$route.params.id).withAllRecursive().first();

      this.dataLoaded = true;
    } catch (errors) {
      errorHandler(errors, this)
    }
  }
}
</script>
